export default __webpack_public_path__ + "1f5bfa680e9246dfba04f5064994b72b.png";